import { createDataStore } from "../../utils/createDataStore";
import { IAuthStore, ICandidateInfoStore } from "./dataStoreTypes";

export const dataStore = {
    auth: createDataStore<IAuthStore>(),
    candidateInfo: createDataStore<ICandidateInfoStore>()
}